import styled from 'styled-components';

import {
  Dropdown as SemanticDropdown,
  Input as SemanticInput,
  Modal as SemanticModal,
  Table as SemanticTable,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

import DatePicker from 'react-datepicker';

export const Table = styled(SemanticTable)``;

export const Text = styled(TextLayoutComponent)``;

export const Status = styled.div`
  display: flex;
  gap: 10px;
`;

export const Link = styled.a``;

export const Dropdown = styled(SemanticDropdown)``;

export const Modal = styled(SemanticModal)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &.ui.modal > .content,
  &.ui.modal > .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
`;

export const Input = styled(SemanticInput)``;

export const ButtonLink = styled.button`
  background: none;
  cursor: pointer;
  color: #2185d0;
  border: none;
  padding: 0;
  font-size: 14px;
  margin-left: 4px;

  &:hover {
    text-decoration: underline;
  }
`;

export const Button = styled(ButtonLayoutComponent)``;

export const ReactDatePicker = styled(DatePicker)`
  width: 114px;

  &&& {
    background: #FFFFFF;
    border-color: #DEDEDF;
    border-radius: 4px;
  }
`;

export const LastCellContentWrapper = styled.span`
  display: block;
  min-width: 80px;
`;
